import { render, staticRenderFns } from "./TasksConfig.vue?vue&type=template&id=62d36f4c&"
import script from "./TasksConfig.vue?vue&type=script&lang=js&"
export * from "./TasksConfig.vue?vue&type=script&lang=js&"
import style0 from "./TasksConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports